import { render, staticRenderFns } from "./TabsBar.vue?vue&type=template&id=7528f54c&scoped=true&"
import script from "./TabsBar.vue?vue&type=script&lang=js&"
export * from "./TabsBar.vue?vue&type=script&lang=js&"
import style0 from "./TabsBar.vue?vue&type=style&index=0&id=7528f54c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7528f54c",
  null
  
)

export default component.exports